module.exports = __webpack_public_path__ + "static/img/wanshang01.ce92e971.jpg";